declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute, Params } from '@angular/router';

import * as alertFunctions from '../../../../shared/data/sweet-alerts';


declare var require: any;

import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
import { NgbAddBill } from './modal/addbill.modal';
import { NgbPayBillModal } from './paybill.modal';
import { PatientInfoByFormattedCodeController, ServicesByCategoryCodeController, ServicesByCategoryCodeRequest, NewBillData, SaveBillItemsInfoRequest, StoreLocationMaterialsRequest, StoreLocationMaterialsController, MaterialBatchInaStoreController, DoctorsListController, DoctorsListRequest, MaterialsListController, MaterialsListRequest, SaveVendorInvoice, VendorInvoiceDetailsController, VendorInvoiceDetailsRequest, VendorInvoiceDetailsInfoController, VendorInvoiceListController, VendorInvoiceItemRequest, S_Methods, SaveDoccumentStateRequest, GenericProcPostRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { PatientInfoByFormattedCodeRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
import { Servicebillpipe, Storelistpipe } from '../../../pipes/actors/actorIdentity.pipes';
import { NgbPaymentModal } from './modal/payment.modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbBatchDetail2Modal } from '../consumptionentry/batchdetail2.modal';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { NgbSearchProviderModal } from '../ivf/ivfworkbench/searchprovider.modal';
import { NgbGoodsInvoiceModal } from './modal/goodsinvoice.modal';
import { NgbEditPIitems2Modal } from './modal/editPIitems2.modal';





@Component({
  selector: 'invoiceedit',
    templateUrl: './invoiceedit.component.html',
    styleUrls: ['./invoiceedit.component.scss']
  , animations: [routerTransition()]
})

export class InvoiceEditComponent implements OnInit {


  public ApiResData: ApiResponseModel;

  public ActorCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
  public ShowList: boolean = true;
  public ShowPatientDetails: boolean = false;
  public receipt: boolean = true;
  public opbilling: boolean = false;
  public Add: boolean = true;
  public Edit: boolean = false;
  public isRequesting: boolean = false;
    public searchValue: string;
  public isvisible: boolean = true;
  public BranchName: string;
  public Date: Date;
  public ActorCode2: number;
  public FacilityCode: number;
  public DocIDData: string;


    searchTitle: string;

  CurrentSaveVendorInvoiceRequest: SaveVendorInvoice;
  PurchaseInvoiceData: SaveVendorInvoice;
  CurrentVendorInvoiceDetailsController: VendorInvoiceDetailsController[];
  CurrentVendorInvoiceDetailsRequest: VendorInvoiceDetailsRequest;
  VendorOrderDataHeader: VendorInvoiceDetailsInfoController;
  CurrentVendorInvoiceHeaderDetailsController: VendorInvoiceListController;

  LoadInvoiceDetails() {
    this.CurrentVendorInvoiceDetailsRequest = new VendorInvoiceDetailsRequest();
    this.CurrentVendorInvoiceDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetVendorInvoiceDetailsController();
  }
  CopyItemsToVendorInvoice() {
    this.PurchaseInvoiceData.OwnerStoreName = this.CurrentVendorInvoiceHeaderDetailsController.OwnerStoreName;
    this.PurchaseInvoiceData.RefDocNo = this.CurrentVendorInvoiceHeaderDetailsController.RefNo;
    this.PurchaseInvoiceData.InvDate = this.CurrentVendorInvoiceHeaderDetailsController.InvoiceDate;
    this.PurchaseInvoiceData.PaymentDue = this.CurrentVendorInvoiceHeaderDetailsController.PaymentDue;
    this.PurchaseInvoiceData.Notes = this.CurrentVendorInvoiceHeaderDetailsController.DeliveryDetails;
    this.PurchaseInvoiceData.Remarks = this.CurrentVendorInvoiceHeaderDetailsController.Remarks;

    this.PurchaseInvoiceData.TaxAmount = this.CurrentVendorInvoiceHeaderDetailsController.TaxAmount;
    this.PurchaseInvoiceData.GrossAmount = this.CurrentVendorInvoiceHeaderDetailsController.GrandTotal;
    this.PurchaseInvoiceData.NetAmount = this.CurrentVendorInvoiceHeaderDetailsController.NetAmount;

    //this.PurchaseOrderData.Tax = this.CurrentPurchaseOrderHeaderDetailsController.Tax;
    //this.PurchaseOrderData.TotalBeforeTax = this.CurrentPurchaseOrderHeaderDetailsController.Net;
    //this.PurchaseOrderData.GrandTotal = this.CurrentPurchaseOrderHeaderDetailsController.GrandTotal;

    this.PurchaseInvoiceData.Items = new Array<VendorInvoiceItemRequest>();
    for (var i = 0; i < this.CurrentVendorInvoiceDetailsController.length; i++) {
      var poItem = new VendorInvoiceItemRequest();
      var OrderItem = this.CurrentVendorInvoiceDetailsController[i];

      poItem.ItemCode = OrderItem.MaterialCode;
      poItem.ItemDescription = OrderItem.MaterialDescription;
      poItem.Quantity = OrderItem.InvoiceQuantity;
      poItem.UOM = OrderItem.UOM;
      poItem.UnitPrice = OrderItem.UnitPrice;
      poItem.TaxPercent = OrderItem.TaxPercent;
      poItem.TaxAmount = OrderItem.TaxAmount;
      poItem.BonusQuantity = OrderItem.BonusQuantity;
      poItem.TotalOrderQuantity = OrderItem.TotalQuantity;
      poItem.Mrp = OrderItem.MRP;
      poItem.Pack = OrderItem.Pack;
      poItem.PurchasePrice = OrderItem.PurchasePrice;
      poItem.SellingPrice = OrderItem.SellingPrice;
      poItem.BatchNo = OrderItem.BatchNo;
      poItem.ExpiryDate = OrderItem.ExpiryDate;
      this.PurchaseInvoiceData.Items.push(poItem);

    }

  }
  GetVendorInvoiceDetailsController() {
    this.StartRefreshing();
    this.CurrentVendorInvoiceDetailsRequest.Invoice = this.DocIDData;
    this.CurrentVendorInvoiceDetailsRequest.ConditionalOperator = 10;
    this.actorservice.GetVendorInvoiceDetailsController(this.CurrentVendorInvoiceDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.VendorOrderDataHeader = this.ApiResData.Result;
          this.PurchaseInvoiceData = new SaveVendorInvoice();
          this.CurrentVendorInvoiceDetailsController = this.VendorOrderDataHeader.InvoiceItems;
          this.CurrentVendorInvoiceHeaderDetailsController = this.VendorOrderDataHeader.InvoiceHeader;
          this.stopRefreshing();
          this.CopyItemsToVendorInvoice();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    private actorservice: ActorService,
    public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService,
    private modalService: NgbModal,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,
    private filter: Storelistpipe, private spinner: NgxSpinnerService


  ) { }

  ngOnInit() {
    this.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.ActorCode2 = AppData.Instance().UserLoginDetails.ActorCode;
    this.DocIDData = this.route.snapshot.paramMap.get('DocIDData');
    this.LoadInvoiceDetails();
    this.CurrentSaveVendorInvoiceRequest = new SaveVendorInvoice();
    this.CurrentSaveVendorInvoiceRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }

  SaveData() {
    //this.isvisible = false;
    this.spinner.show();

    this.CurrentSaveVendorInvoiceRequest.Facility = AppData.Instance().SelectedBranchCode;
    this.CurrentSaveVendorInvoiceRequest.DocID = this.CurrentVendorInvoiceHeaderDetailsController.DocID;
    this.CurrentSaveVendorInvoiceRequest.InvDate = this.CurrentVendorInvoiceHeaderDetailsController.InvoiceDate;
    this.CurrentSaveVendorInvoiceRequest.PaymentDue = this.CurrentVendorInvoiceHeaderDetailsController.PaymentDue;
    this.CurrentSaveVendorInvoiceRequest.VendorCode = this.CurrentVendorInvoiceHeaderDetailsController.VendorInvoiceCode;
    this.CurrentSaveVendorInvoiceRequest.VendorName = this.CurrentVendorInvoiceHeaderDetailsController.SupplierName;
    this.CurrentSaveVendorInvoiceRequest.VendorInvoiceCode = this.CurrentVendorInvoiceHeaderDetailsController.VendorInvoiceCode;
    this.CurrentSaveVendorInvoiceRequest.RefDocNo = this.CurrentVendorInvoiceHeaderDetailsController.RefNo;
    //this.CurrentSaveVendorInvoiceRequest.PurchaseOrderCode = this.CurrentVendorInvoiceHeaderDetailsController.PO;
    this.CurrentSaveVendorInvoiceRequest.InvoiceStatus = this.CurrentVendorInvoiceHeaderDetailsController.Status;
    this.CurrentSaveVendorInvoiceRequest.Remarks = this.PurchaseInvoiceData.Remarks;
    this.CurrentSaveVendorInvoiceRequest.Notes = this.PurchaseInvoiceData.Notes;
    this.CurrentSaveVendorInvoiceRequest.OwnerStore = this.CurrentVendorInvoiceHeaderDetailsController.OwnerStore;
    this.CurrentSaveVendorInvoiceRequest.OwnerStoreName = this.CurrentVendorInvoiceHeaderDetailsController.OwnerStoreName;
    this.CurrentSaveVendorInvoiceRequest.ConditionalOperator = 20;
    this.CurrentSaveVendorInvoiceRequest.Items = this.PurchaseInvoiceData.Items;
    this.CurrentSaveVendorInvoiceRequest.TaxAmount = this.PurchaseInvoiceData.TaxAmount;
    this.CurrentSaveVendorInvoiceRequest.TotalBeforeDesc = this.PurchaseInvoiceData.TotalBeforeDesc;
    this.CurrentSaveVendorInvoiceRequest.GrossAmount = this.PurchaseInvoiceData.GrossAmount;
    this.CurrentSaveVendorInvoiceRequest.NetAmount = this.PurchaseInvoiceData.NetAmount;
    //this.CurrentSaveVendorInvoiceRequest.Terms = this.TermsAndConditions;
    this.CurrentSaveVendorInvoiceRequest.InvFormattedCode = this.PurchaseInvoiceData.InvFormattedCode;
    //this.CurrentSaveVendorInvoiceRequest.InvoiceStatus = this.PurchaseInvoiceData.InvoiceStatus;
    this.actorservice.Save<SaveVendorInvoice>(
      this.CurrentSaveVendorInvoiceRequest, S_Methods.SaveVendorInvoices
    )
      .subscribe((result) => {
        this.ApiResData = result;
        if (result.Result > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
          this.spinner.hide();
          this.isvisible = false;
        }
        else {
          alertFunctions.AlertParam("Invalid Operation :- " + "...!");
          this.stopRefreshing();
          this.spinner.hide();
        }
      },
        (error) => {
          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );
  }

  Finalize() {
    var saveReq = new SaveDoccumentStateRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 20062; // reque for Invoice approval
    saveReq.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.ActionTag = "Finalize";
    saveReq.DocumentType = 102; // Invoice docment
    saveReq.DocCode = this.CurrentVendorInvoiceHeaderDetailsController.VendorInvoiceCode;
    saveReq.DocID = this.DocIDData;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 20062;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.router.navigate(['healins/materialinvoice']);
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alertFunctions.ShowMessage('Internal Issues UNKNOWN', this.ApiResData.ErrorData, 'error');
            //alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            //this.spinner.hide();
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  EditItems(PurchaseInvoiceData: SaveVendorInvoice, input: VendorInvoiceItemRequest) {
    const modalRef = this.modalService.open(NgbEditPIitems2Modal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.PurchaseInvoiceItem = input;
    modalRef.componentInstance.PurchaseInvoiceData = PurchaseInvoiceData;
    modalRef.componentInstance.VendorName = this.CurrentVendorInvoiceHeaderDetailsController.SupplierName;
    modalRef.componentInstance.OwnerStoreName = this.CurrentVendorInvoiceHeaderDetailsController.OwnerStoreName;
    //modalRef.componentInstance.ExpiryDate = this.PurchaseInvoiceData.ExpiryDate;
    modalRef.componentInstance.PurchaseOrderCode = this.CurrentVendorInvoiceHeaderDetailsController.VendorInvoiceNo;
    modalRef.result.then((l: VendorInvoiceItemRequest) => {
      input.UnitPrice = l.UnitPrice;
      input.TotalOrderQuantity = l.Quantity + l.BonusQuantity;
      input.BonusQuantity = l.BonusQuantity;
      input.TaxPercent = l.TaxPercent;

      input.Quantity = l.Quantity;



      input.UOM = l.UOM;
      input.Mrp = l.Mrp;
      input.Pack = l.Pack;
      input.PurchasePrice = l.PurchasePrice;
      input.SellingPrice = l.SellingPrice;

      input.TaxAmount = ((l.Quantity + l.BonusQuantity) * l.PurchasePrice * l.TaxPercent) / 100;
      input.BatchNo = l.BatchNo;
      input.ExpiryDate = l.ExpiryDate;
      // alert(l.ExpiryDate);
      this.CalculateTotals();
    });
  }
  CalculateTotals() {

    this.PurchaseInvoiceData.TaxAmount = this.PurchaseInvoiceData.Items.filter((item) => item.TaxAmount)
      .map((item) => +item.TaxAmount)
      .reduce((sum, current) => sum + current);
    this.PurchaseInvoiceData.GrossAmount = this.PurchaseInvoiceData.Items.filter((item) => item.PurchasePrice)
      .map((item) => +item.PurchasePrice)
      .reduce((sum, current) => sum + current) * this.PurchaseInvoiceData.Items.filter((item) => item.Quantity)
      .map((item) => +item.Quantity)
        .reduce((sum, current) => sum + current);
    this.PurchaseInvoiceData.NetAmount = this.PurchaseInvoiceData.GrossAmount + this.PurchaseInvoiceData.TaxAmount;

  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  Cancel() {
      this.router.navigate(['healins/materialinvoice']);
  }


}


